import { Helmet } from 'react-helmet'
import React, { PureComponent } from 'react'


export default class DefaultHead extends PureComponent {

  render() {
    return (
      <Helmet>
        <meta
          httpEquiv="X-UA-Compatible"
          content="IE=edge"
        />
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width"
        />
      </Helmet>
    )
  }

}
